import corpo from '@/assets/home-v2/corpo-braco.webp.asset.json';
import maos from '@/assets/home-v2/maos-mesa.webp.asset.json';
import pes from '@/assets/home-v2/pes-uso.webp.asset.json';
import sab from '@/assets/home-v2/sab-rosto.webp.asset.json';
import { Reveal, Eyebrow, H2 } from './shared';

const PHOTOS = [
  { src: corpo.url, title: 'Corpo', text: 'Depois do banho, todo dia.' },
  { src: maos.url, title: 'Mãos', text: 'Depois de lavar, quantas vezes precisar.' },
  { src: pes.url, title: 'Pés', text: 'Depois do banho, calça logo em seguida.' },
  { src: sab.url, title: 'Rosto', text: 'Limpeza suave, sem perfume.' },
];

export const RoutinePhotos = () => (
  <Reveal as="section" className="bg-v2-bg text-v2-ink py-16 md:py-24">
    <div className="container mx-auto px-5 max-w-6xl">
      <Eyebrow>Na rotina de verdade</Eyebrow>
      <H2 className="max-w-xl">No corpo, nas mãos, nos pés, no rosto.</H2>
      <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {PHOTOS.map((p) => (
          <figure key={p.title} className="min-w-0">
            <div className="rounded-2xl overflow-hidden aspect-[3/2] bg-v2-ink/5">
              <img src={p.src} alt={`${p.title}: ${p.text}`} width={900} height={600} loading="lazy" decoding="async" className="w-full h-full object-contain" />
            </div>
            <figcaption className="mt-3 text-base">
              <span className="font-semibold block">{p.title}</span>
              <span className="text-v2-muted">{p.text}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </Reveal>
);
